import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SelectWithTooltip from '../../SelectWithTooltip/SelectWithTooltip';

// Generic rjsf select widget with per-option hover tooltips.
// Pass tooltips via uiSchema: 'ui:options': { optionTooltips: { <optionValue>: 'tooltip text', ... } }
const SelectWithTooltipInternal = observer(class SelectWithTooltipInternal extends Component {
    render() {
        const { options = {}, value, onChange, schema, disabled } = this.props;
        const { enumOptions = [], optionTooltips = {} } = options;
        const __disabled = schema && schema.readOnly !== undefined ? !!schema.readOnly : !!disabled;

        const selectOptions = enumOptions.map(opt => ({
            value: opt.value,
            label: opt.label,
            tooltip: optionTooltips[opt.value] || null,
        }));
        const selected = selectOptions.find(opt => opt.value === value) || null;

        return (
            <SelectWithTooltip
                options={selectOptions}
                value={selected}
                isDisabled={__disabled}
                onChange={(sel) => onChange(sel ? sel.value : '')}
            />
        );
    }
});

export const SelectWithTooltipWidget = observer(class SelectWithTooltipWidget extends Component {
    render() {
        return <SelectWithTooltipInternal {...this.props} />;
    }
});

export default SelectWithTooltipWidget;
